var _rect, _rect2, _path, _rect3, _rect4, _path2, _path3, _path4, _rect5, _rect6, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternalCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 24,
    viewBox: "0 0 100 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    stroke: "#EAECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0503 15.8487H8.99061L7.44605 9.7828C7.37274 9.50377 7.21708 9.25709 6.98811 9.14083C6.41668 8.84866 5.78701 8.61613 5.1001 8.49886V8.26532H8.41818C8.87612 8.26532 9.21958 8.61613 9.27682 9.02355L10.0782 13.3991L12.137 8.26532H14.1395L11.0503 15.8487ZM15.2843 15.8487H13.3391L14.9409 8.26532H16.8861L15.2843 15.8487ZM19.4028 10.3661C19.46 9.9577 19.8035 9.72417 20.2042 9.72417C20.8339 9.66553 21.5198 9.7828 22.0922 10.074L22.4357 8.44124C21.8632 8.2077 21.2336 8.09043 20.6621 8.09043C18.7741 8.09043 17.4003 9.14083 17.4003 10.5987C17.4003 11.7077 18.3734 12.29 19.0603 12.6408C19.8035 12.9906 20.0897 13.2242 20.0325 13.574C20.0325 14.0987 19.46 14.3322 18.8886 14.3322C18.2017 14.3322 17.5148 14.1573 16.8861 13.8651L16.5427 15.4989C17.2296 15.79 17.9727 15.9073 18.6596 15.9073C20.7766 15.9649 22.0922 14.9155 22.0922 13.3404C22.0922 11.3569 19.4028 11.2406 19.4028 10.3661ZM28.9001 15.8487L27.3555 8.26532H25.6965C25.353 8.26532 25.0096 8.49886 24.8951 8.84866L22.035 15.8487H24.0375L24.4372 14.7406H26.8976L27.1266 15.8487H28.9001ZM25.9827 10.3075L26.5541 13.1655H24.9523L25.9827 10.3075Z",
    fill: "#172B85"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    stroke: "#EAECF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3982 5.3C63.1431 5.3 66.1794 8.29989 66.1794 12.0002C66.1793 15.7004 63.143 18.7004 59.3982 18.7004C57.7192 18.7004 56.184 18.0956 54.9998 17.0969C53.8156 18.0955 52.2802 18.7004 50.6013 18.7004C46.8567 18.7002 43.8212 15.7003 43.821 12.0002C43.821 8.30002 46.8566 5.30022 50.6013 5.3C52.28 5.3 53.8156 5.90408 54.9998 6.90254C56.1839 5.90394 57.7194 5.30003 59.3982 5.3Z",
    fill: "#ED0006"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3984 5.3C63.1432 5.30008 66.1787 8.29994 66.1787 12.0002C66.1786 15.7004 63.1432 18.7003 59.3984 18.7004C57.7195 18.7004 56.1842 18.0956 55 17.0969C56.4572 15.868 57.3828 14.0415 57.3828 12.0002C57.3828 9.9587 56.4574 8.13144 55 6.90254C56.1842 5.904 57.7196 5.3 59.3984 5.3Z",
    fill: "#F9A000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9995 6.90253C56.4571 8.13143 57.3823 9.95855 57.3823 12.0002C57.3823 14.0416 56.4568 15.868 54.9995 17.0969C53.5425 15.868 52.6177 14.0413 52.6177 12.0002C52.6177 9.95884 53.5423 8.13142 54.9995 6.90253Z",
    fill: "#FF5E00"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 76.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 76.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#EAECF0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 12,
    r: 2,
    fill: "#98A2B3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 12,
    r: 2,
    fill: "#98A2B3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 12,
    r: 2,
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalCard);
export default __webpack_public_path__ + "static/media/internal-card.d46b7c6ff9e1e75ff0a9a4894b4a9913.svg";
export { ForwardRef as ReactComponent };